/**
 * @file Re-exports the InvestmentDescriptions component.
 */
import InvestmentDescriptions from "./InvestmentDescriptions";

export default InvestmentDescriptions;
